module.exports = __webpack_public_path__ + "static/media/icon_xlqhx.19c0502b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_xlqhx.png
// module id = 2166
// module chunks = 0